import { useEffect, useMemo } from "react";

import { getIn, useFormikContext } from "formik";

import { RowContainerProps } from "@sso/ui/FlexBox";

import Typeahead from "../Form/Typeahead";

interface FormikTypeaheadProps {
  label: string;
  items: AutoCompleteOption[];
  value?: AutoCompleteOption;
  openUpward?: boolean;
  onSearch: (searchItem: string) => void;
  heightOffset?: number;
  maxHeight?: number;
  fieldProps?: RowContainerProps;
  error?: boolean;
  disabled?: boolean;
  name: string;
  clear: () => void;
  handleChange?: (value: string | number) => void;
}

export type AutoCompleteOption = {
  key: string | number;
  value: string | number;
  label: string;
  elementLabel?: JSX.Element;
};

const FormikTypeahead = (props: FormikTypeaheadProps) => {
  const {
    setFieldValue,
    setFieldTouched,
    getFieldMeta,
    errors,
    handleChange: formikChange,
    handleBlur: formikBlur,
    validateField,
  } = useFormikContext();

  const { value: currentValue, touched: fieldTouched } = getFieldMeta(props.name);
  const fieldErrors = getIn(errors as any, props.name);

  const value = useMemo(() => {
    return props.items.find(option => {
      return option.value === currentValue;
    });
  }, [currentValue]);

  useEffect(() => {
    setTimeout(() => {
      validateField(props.name);
    }, 5);
  }, [currentValue]);

  const onChange = (value: string | number) => {
    formikChange({ target: { name: props.name, value } });
    setFieldValue(props.name, value);

    if (props.handleChange) {
      props.handleChange(value);
    }
  };

  const onBlur = () => {
    setFieldTouched(props.name, true);
  };

  const handleClear = () => {
    props.clear();
    setFieldValue(props.name, undefined);
    formikChange({ target: { name: props.name, value: undefined } });
  };

  return (
    <Typeahead
      maxHeight={200}
      onClear={() => handleClear()}
      value={value}
      error={fieldTouched && fieldErrors}
      errorText={fieldErrors}
      onBlur={onBlur}
      onChange={onChange}
      {...props}
    ></Typeahead>
  );
};

export default FormikTypeahead;
